import React from 'react';
import { DelayedTooltip } from './DelayedTooltip';

interface SideNavTooltipProps {
  label: string;
  children: React.ReactElement;
}

/** Side nav icon labels — delayed hover tooltip, portaled above slideout header. */
export const SideNavTooltip: React.FC<SideNavTooltipProps> = ({
  label,
  children
}) => (
  <DelayedTooltip
    message={label}
    placement="left"
    inlineFlex
    cursor="pointer"
    ariaLabel={label}
  >
    {children}
  </DelayedTooltip>
);
